import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/reporting/')({
  async beforeLoad({ context }) {
    const hasViewPermission = await context.hasPermission(
      'campaignInsightsFeature:view',
    );
    throw redirect({
      to: hasViewPermission ? '/reporting/dashboards' : '/campaigns',
    });
  },
});
